
/* eslint-disable */
import { Options, Vue } from "vue-class-component"
import { Prop, Watch } from "vue-property-decorator"
import { CloudManager } from "@/assets/cloud"
import { Animator } from "@/assets/animation"
import { PlotHandler } from "@/assets/plot"
import { FontConfig } from "@/assets/variable-font"
import { createBackground, fragment } from "@/assets/gl-helper"
import * as ColorPreset from "@/assets/color-preset"
import { createColorPicker } from "@/assets/color-picker"
import Slider from "@/components/ui/Slider.vue"
import "bootstrap"
import * as d3 from "d3"
import * as dsv from "d3-dsv"
import { Word, Mode, Style, Dataset } from "@/assets/types"

@Options({
  components: {
    Slider
  }
})
export default class Playground extends Vue {
  public wordleData: Dataset | null = null
  public collection: Dataset[] = []
  public fileReader = new FileReader()
  public uploadFilename: string = ""
  public animationModes: Array<Mode> = [Mode.bubble, Mode.split, Mode.electric]
  public animationMode: Mode = Mode.bubble
  public fontFamily = 'NotoSans'
  public fontStyle = 'normal'
  public fontWeight = 'normal'
  public colorSchemes = ['red', 'black', 'Viridis', 'Plasma', 'rainbow']
  public colorScheme = 'red'
  public easeTypes = ['Cubic', 'ElasticIn', 'ElasticOut', 'BounceIn', 'BounceOut', 'BounceInOut']
  public easeType = 'BounceIn'
  public strokeWidth = '2px'
  public rotation: number = 0
  public duration: number = 5000
  public cloudManager: CloudManager | undefined
  public customColor = "#000000"
  public presetColors = ColorPreset.rainbow
  public bgAnimator: any
  public animator: null | Animator = null
  get styleScheme ():Style {
    return {
      colorScheme: this.colorScheme,
      fontStyle: this.fontStyle,
      fontWeight: this.fontWeight,
      fontFamily: this.fontFamily,
      font: new FontConfig(),
      strokeWidth: this.strokeWidth,
      rotation: this.rotation,
      height: 520,
      width: 800
    }
  }
  created() {
  }
  mounted() {
    // test function only
    this.testFunc()
    this.fileReader.addEventListener("load", this.parseFile, false)
    //let fileNames = ["2020_search", "xmas", "xmas-emoji", "thx", "Poe", "creep", "creep_emoji", "creep_mask"]
    let fileNames = ["creep","2020_search", "thx"]
    let tasks = fileNames.map((tag: string) => d3.json(`./dataset/layout/layout_${tag}.json`))
    Promise.all(tasks).then((dataList: any) => {
      this.collection = dataList.map((data: Word[], idx: number) => {
        return {
          tag: fileNames[idx],
          data: data
        }
      })
      this.wordleData = this.collection[0]
      d3.select('#dataset')
        .selectAll('option')
        .property('selected', 'false')
        .filter((v: any) => v['data-tag']==this.collection[0].tag)
        .property('selected', true)
    })
    //createColorPicker('black', this.presetColors, '.color-picker')
  }
  @Watch('wordleData')
  wordleDataChanged() {
    if (!this.wordleData) return
    if(this.cloudManager) {
      this.cloudManager.stop()
    }
    this.animator = new Animator(
      assignColor(this.wordleData!.data),
      new PlotHandler("", "emotional-wordle-svg", this.styleScheme, false),
      this.duration,
      this.bgAnimator,
    )
    this.animator.play()
  }
  @Watch('easeType')
  easeTypeChanged() {
    if(!this.animator) return
    this.animator.update('ease', this.easeType)
    this.animator!.play()
  }
  @Watch('styleScheme')
  schemeChanged() {
    this.wordleDataChanged()
  }
  @Watch('animationMode')
  animationModeChanged() {
    if (!this.animator) return
    if( this.animationMode === Mode.bubble ) this.easeType = 'elasticIn'
    this.animator.update('mode', this.animationMode)
    this.animator.play()
  }
  async testFunc() {
    // createBackground(`#emotional-wordle-bg-canvas`, this.styleScheme.width, this.styleScheme.height)
    await fragment(`#emotional-wordle-bg-canvas`, this.styleScheme.width, this.styleScheme.height)
      .then((v) => {
      this.bgAnimator = v
    })
    
  }
  speedCallback(v: number) {
    this.duration = v
    if(!this.animator) return
    this.animator.update('duration', v)
    this.animator.play()
  }
  rotateCallback(v: number) {
    this.rotation = v
  }
  handleUpload(event: any) {
    let file = event.target.files[0]
    if (!file) return
    this.fileReader.readAsText(file)
    this.uploadFilename = file.name.split('.csv')[0]
    this.collection.forEach((dataset: Dataset) => {
      if (dataset.tag == this.uploadFilename) {
        this.uploadFilename += Math.random().toString() + Math.random.toString()
      }
    })
  }
  pause() {
    let ele = "#pauseButton"
    let state = !d3.select(ele).classed("active")
    d3.select(ele).classed("active", state)
    d3.select("#playButton").classed("active", !state)
    if(!this.cloudManager) return
    this.cloudManager!.stop()
  }
  play() {
    let ele = "#playButton"
    let state = !d3.select(ele).classed("active")
    d3.select(ele).classed("active", state)
    d3.select("#pauseButton").classed("active", !state)
    if(!this.animator) return
    this.animator!.play()
  }
  replay() {
    if(!this.animator) return
    this.animator!.play()
  }
  parseFile() {
    let res = this.fileReader.result
    if (!res || typeof res !== 'string') return
    let data = dsv.csvParse(res, (item: any) => {
        return {
          frequency: parseFloat(item.frequency),
          text: item.text
        }
      })
    let dataset = {
      data: data,
      tag: this.uploadFilename
    }
    this.collection.push(dataset)
    d3.select('#dataset').property('value', dataset)
    this.wordleData = dataset
  }
  updateColor() {
    console.log(this.customColor)
  }
  downloadGif() {
    if(!this.cloudManager) return
    this.cloudManager.animator!.createGif()
  }
  downloadJson() {
    if (!this.wordleData) return
    const a = document.createElement('a')
    a.href = URL.createObjectURL( new Blob([JSON.stringify(this.wordleData.data)], { type:`text/json` }) );
    a.download = `layout_${this.wordleData.tag}.json`
    a.click()
    a.remove()
  }
  openFile() {
    document.getElementById("wordleUpload")!.click()
  }
}
let assignColor = function (words: Word[]) {
  words.forEach((word: Word, idx: number) => {
    word.color = "black";
  });
  return words;
};
